import Vue from "vue";
import VueRouter from "vue-router";
import vueResource from "vue-resource";
import Resource from "vue-loading-overlay";
import VueFuse from "vue-fuse";
import VueTabs from "vue-nav-tabs";
import "vue-nav-tabs/themes/vue-tabs.css";
import Moment from "moment";
import Numeral from "numeral";
import axios from "axios";
import vSelect from "vue-select";
import TaxPayerId from "@/components/TaxPayerId.vue";
import Logout from "@/components/Logout.vue";
import AuditTrailEntity from "@/components/AuditTrail/AuditTrailEntity.vue";
import "vue-loading-overlay/dist/vue-loading.css";
import "vue-select/dist/vue-select.css";
import 'leaflet/dist/leaflet.css';
import "@/assets/scss/element.scss";
import "@/assets/css/sidebar.css";
import DashboardPlugin from "./material-dashboard";
import store from "./store";
import Constants from "./constants";
import MdStatus from "@/components/MdStatus.vue";

const apiRoot =
  process.env.NODE_ENV !== "development" ? "" : "http://localhost:9000";
const serverUrl = `${apiRoot}/api/v1/`;

const axiosClient = axios.create({
  baseURL: serverUrl
});

Constants.install = function () {
  Object.defineProperty(Vue.prototype, "$constants", {
    get() {
      return Constants;
    }
  });

  Object.defineProperty(Vue.prototype, "$moment", {
    get() {
      return Moment;
    }
  });

  Object.defineProperty(Vue.prototype, "$numeral", {
    get() {
      return Numeral;
    }
  });

  Object.defineProperty(Vue.prototype, "$axios", {
    get() {
      return axiosClient;
    }
  });

  Object.defineProperty(Vue.prototype, "$formatMoney", {
    get() {
      return formatMoney;
    }
  });

  Object.defineProperty(Vue.prototype, "$yearRange", {
    get() {
      // Generate a list of years for the last n years
      const n = 20
      const currentYear = new Date(Date.now()).getFullYear() + 1;
      const startYear = currentYear - n;

      const yearRange = [];

      for (let i = startYear; i < currentYear; i++) {
        yearRange.push(i);
      }

      return yearRange;
    }
  });

  Object.defineProperty(Vue.prototype, "$logout", {
    get() {
      return logout;
    }
  });
};

// Plugins
import App from "./App.vue";
import Chartist from "chartist";
import Tawk  from "vue-tawk"

// router setup
import routes from "./routes/routes";
import { formatMoney, logout } from "./lib/utils";

Vue.component("v-select", vSelect);
Vue.component("tax-payer-id", TaxPayerId);
Vue.component("logout", Logout);
Vue.component("AuditTrailEntity", AuditTrailEntity);
Vue.component("md-status", MdStatus);

// plugin setup
Vue.use(VueRouter);
Vue.use(DashboardPlugin);
Vue.use(vueResource);
Vue.use(Resource, {
  color: "#4caf50",
  height: 50,
  width: 50,
  backgroundColor: "#040404"
});
Vue.use(Constants);
Vue.use(VueFuse);
Vue.use(VueTabs);

Vue.http.options.root = serverUrl;
Vue.http.options.credentials = true;

// Intercepting Requests to add Loader
Vue.http.interceptors.push(request => {
  // The skip loader param is used to prevent the loader from being triggered, especially when batching requests
  const { skipLoader } = request.params || {};

  let loading;

  if (!skipLoader) {
    loading = Vue.$loading.show({
      zIndex: 10002
    });
  } else {
    delete request.params.skipLoader;
  }

  const loginUrl = window.location.pathname.includes("/user/") ? "/login" : "/admin/login";

  return response => {
    Vue.use(Tawk, {
      tawkSrc: 'https://embed.tawk.to/5dc098ba154bf74666b77934/default'
    })
    // Dismiss the loader
    if (!skipLoader) {
      loading.hide();
    }

    // Handle Expired Access Tokens
    if (response.body.code && response.body.code === "NO_AUTH") {
      const isLoginUrl = window.location.pathname.includes("login");
      // Clean up the storage data and route to login.
      try {
        localStorage.removeItem('etax');
        sessionStorage.removeItem('user');
      }catch(e) {
        if(!isLoginUrl) return router.push(loginUrl);
      }

      if(!isLoginUrl) return router.push(loginUrl);
    } else {
      if(request.url === 'touch' && Constants.loginUrls.includes(window.location.pathname)) {
        let profileUrl = '/user/profile';
        switch(window.location.pathname) {
          case '/admin/login':
            profileUrl = '/user-profile';
            break;
          case '/consultant/login':
            profileUrl = '/consultant/dashboard';
            break;
        }
        router.push(profileUrl);
      }
    }
  };
});

// configure router
const router = new VueRouter({
  mode: "history",
  linkExactActiveClass: "nav-item active",
  routes, // short for routes: routes,
  scrollBehavior() {
    return { x: 0, y: 0 };
  }
});

// global library setup
Object.defineProperty(Vue.prototype, "$Chartist", {
  get() {
    return this.$root.Chartist;
  }
});

/* eslint-disable no- new */
new Vue({
  data: {
    Chartist
  },
  el: "#app",
  render: h => h(App),
  router,
  store
});
